var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C18.5625 6 19.0312 6.19792 19.4062 6.59375C19.8021 6.96875 20 7.4375 20 8V11.5C20 11.6458 19.9479 11.7708 19.8438 11.875C19.7604 11.9583 19.6458 12 19.5 12H18V15C18 15.2708 17.8958 15.5 17.6875 15.6875C17.5 15.8958 17.2708 16 17 16H7C6.72917 16 6.48958 15.8958 6.28125 15.6875C6.09375 15.5 6 15.2708 6 15V12H4.5C4.35417 12 4.22917 11.9583 4.125 11.875C4.04167 11.7708 4 11.6458 4 11.5V8C4 7.4375 4.1875 6.96875 4.5625 6.59375C4.95833 6.19792 5.4375 6 6 6V1C6 0.729167 6.09375 0.5 6.28125 0.3125C6.48958 0.104167 6.72917 0 7 0H15.5938C15.8646 0 16.0938 0.09375 16.2812 0.28125L17.7188 1.71875C17.9062 1.90625 18 2.13542 18 2.40625V6ZM16 14V11H8V14H16ZM16 7V4H14.5C14.3542 4 14.2292 3.95833 14.125 3.875C14.0417 3.77083 14 3.64583 14 3.5V2H8V7H16ZM16.9688 9.03125C17.1146 9.17708 17.2917 9.25 17.5 9.25C17.7083 9.25 17.8854 9.17708 18.0312 9.03125C18.1771 8.88542 18.25 8.70833 18.25 8.5C18.25 8.29167 18.1771 8.11458 18.0312 7.96875C17.8854 7.82292 17.7083 7.75 17.5 7.75C17.2917 7.75 17.1146 7.82292 16.9688 7.96875C16.8229 8.11458 16.75 8.29167 16.75 8.5C16.75 8.70833 16.8229 8.88542 16.9688 9.03125Z",
    fill: "#2E3638"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.072a7bbc1ad628ffe95c79ad04393fea.svg";
export { ForwardRef as ReactComponent };